import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';

var CaretDownIcon = function CaretDownIcon(_a) {
  var className = _a.className,
    otherProps = __rest(_a, ["className"]);
  return jsx("svg", Object.assign({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-label": "CaretDownIcon",
    role: "img",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    width: "16",
    height: "16",
    fill: "none",
    className: classNames('cogs-icon', className)
  }, otherProps, {
    children: jsx("path", {
      fill: "currentColor",
      d: "m8.53 9.604 1.965-2.35c.332-.398.499-.597.505-.766a.48.48 0 0 0-.161-.38C10.716 6 10.466 6 9.965 6h-3.93c-.5 0-.751 0-.874.107a.48.48 0 0 0-.16.381c.005.17.172.368.504.766l1.965 2.35c.183.22.275.329.383.37a.42.42 0 0 0 .294 0c.108-.041.2-.15.383-.37"
    })
  }));
};

export { CaretDownIcon };
